import Vue from 'vue';

const title = Vue.directive('title', {
	inserted: function (el, binding) {
    document.title = el.innerText
    el.remove()
  }
})

export { title }
